let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cT5yc")).then(() => parcelRequire('jMC6T'));